import { styledComponent } from 'lib/styled_component';

import { NavLink } from 'react-router-dom';

import cardCSS from './css';

const CardLink = styledComponent(NavLink)`
    ${cardCSS}
`;

export default CardLink;
